import { useState } from 'react';

const AUTH_STORAGE_KEY = 'isLoggedIn';

export interface AuthState {
  isLoggedIn: boolean;
  login: () => void;
  logout: () => void;
}

export const useAuth = (): AuthState => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(() => {
    const storedLoginState = window.sessionStorage.getItem(AUTH_STORAGE_KEY);
    return storedLoginState === 'true';
  });

  const login = () => {
    setIsLoggedIn(true);
    window.sessionStorage.setItem(AUTH_STORAGE_KEY, 'true');
  };

  const logout = () => {
    setIsLoggedIn(false);
    window.sessionStorage.setItem(AUTH_STORAGE_KEY, 'false');
    window.location.reload();
  };

  return { isLoggedIn, login, logout };
};